export default "__VITE_ASSET__BgIMrM6O__"